import { Theme } from '@/interfaces/theme'

// Ensure your Theme enum includes A2B, e.g.:
// enum Theme {
//   BASE = "BASE",
//   A2B = "A2B"
// }

/**
 * Set the application's theme.
 * base.css is statically imported in main.ts.
 * a2b.css is dynamically imported if selected.
 */

export const setTheme = (themeString: string | undefined): Theme => {
  // Theme ref to hold the selected theme
  const currentTheme: Ref<Theme> = ref(Theme.BASE)

  if (themeString !== undefined) {
    // Convert the string to a enum Theme
    const themeKey = themeString.toUpperCase() as keyof typeof Theme

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (Object.values(Theme).includes(Theme[themeKey])) {
      const selectedEnumValue = Theme[themeKey]

      // Apply the selected theme value (enum)
      currentTheme.value = selectedEnumValue

      if (selectedEnumValue === Theme.A2B) {
        // Dynamically import a2b.css
        import('../../assets/themes/a2b.css')
          .then(() => {
            console.log('Successfully dynamically imported a2b.css')
          })
          .catch((error) => {
            console.error('Failed to dynamically import a2b.css, error was:', error)
            // Fallback to base theme if a2b.css fails to load
            currentTheme.value = Theme.BASE
            throw error
          })
      }
    } else {
      console.log(`Theme string provided: "${themeString}". Falling back to BASE theme.`)
      currentTheme.value = Theme.BASE
    }
    // themeString was undefined, default to BASE
    currentTheme.value = Theme.BASE
  }
  // Handle case where themeString is undefined
  return currentTheme.value
}
